import { getCurrentLanguage } from 'src/Libs/languages/functions/default'
import { CategoryNames } from '../dto'
import { BreadcrumbItem } from '../models'

export const getCategoryName = (id: number, names: CategoryNames): string => {
  const appLanguage = getCurrentLanguage()

  if (id === 0) {
    return 'downloads.root-category-name'
  }

  return names[appLanguage]
}

export const getItemName = (id: number, name: string): string => {
  if (id === 0) {
    return 'downloads.root-category-name'
  }

  return name
}

export const goToDirectParent = (
  parentCategories: BreadcrumbItem[],
  onClickCategory?: (id: number) => void,
  onClickBackButton?: () => void
): void => {
  const directParentId = parentCategories.length <= 1 ? 0 : parentCategories.at(-2)!.id

  if (onClickBackButton) {
    onClickBackButton()
  } else {
    onClickCategory?.(directParentId)
  }
}
